import { Box, SxProps, Theme } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";

interface DatePickerComponentProps {
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  sx?: SxProps<Theme>;
  isLoading: boolean;
}

export function DatePickerComponent({
  value,
  onChange,
  sx,
  isLoading,
}: DatePickerComponentProps) {
  return (
    <Box>
      <DatePicker
        disabled={isLoading}
        timezone="UTC"
        value={value ? dayjs.utc(value) : null}
        onChange={(newValue) => onChange(newValue ? dayjs.utc(newValue) : null)}
        slotProps={{
          textField: {
            size: "small",
            variant: "standard",
            sx: {
              ...sx,
            },
          },
          openPickerIcon: {
            sx: {
              width: "20px",
              height: "20px",
            },
          },
        }}
      />
    </Box>
  );
}
